import * as Logger from './logger.js'
import { HSComponent } from './component.js';
import { HSGridStack } from './gridstack.js';
import styles from './blade.css';
import template from './blade.html';

export class HSBlade extends HSComponent {
    title;
    back_link_text = "go back";
    gridstack;

    constructor() { 
        super();
    }

    onLoad() {
        this.loadTemplate(template);
        this.loadStyles(styles);
        const overlay = this.shadowRoot.querySelector('.overlay');
        this.onEvent('click', () => this.close(), overlay);   // TODO: not working...
        this.onEvent('keydown', (opts, ev) => { if (ev.key === 'Escape' && this.isOpen) { this.close(); } }, document);
    }

    onUnload() {
        Logger.debug("unload blade called...");
        this.abort();
    }

    init({ id, title, grids = [], cards = [] } = {}) {
        this.setAttribute('id', id);

        // setup the blade header (TODO: this needs work here and in CSS)
        this.shadowRoot.querySelector(".title").textContent = title;
        const backButton = this.shadowRoot.querySelector(".back-button");
        backButton.textContent = '<< Go back';
        this.onEvent('click', () => this.close(), backButton);

        // setup the blade content as a gridstack with the specified subgrids/cards
        this.gridstack = document.createElement('hs-gridstack');
        this.appendChild(this.gridstack);
        this.gridstack.init(grids, cards);
        this.gridstack.toggleEditMode(this.editMode);

        // have the blade open with animation
        setTimeout(() => this.open(), 10);
    }

    open() {
        if (this.isOpen) { return; }
        this.isOpen = true;
        this.classList.add('open');
    }

    close() {
        if (!this.isOpen) { return; }
        this.isOpen = false;
        this.classList.remove('open');

        // allow blade to animate close before we unload the content
        setTimeout(() => {
            this.emit({ type: 'hs-unload-blade', blade: this });
        }, 2000);
    }
}
customElements.define('hs-blade', HSBlade);

